<template >
  <div>
    <va-card style="height:600px!important;background-color:#F4F3EF!important;">
      <vue-element-loading :active="visible" :is-full-screen="true" />
      <div class="row">
        <div class="flex md3 sm6 xs12"></div>
        <div class="flex md6 sm6 xs12">
          <va-card class="shadow p-3 mb-5 bg-white rounded" style="height:800px!important;">
            <h4 style="font-size:24px!important;padding-top:20px;" class="news2">UPDATE CRIME TYPE</h4>
            <form @submit="onSubmit">
              <div style="padding-top:20px;" class="flex md12 sm6 xs12">
                <va-input required v-model="cname" placeholder="Crime Type" />
              </div>
              <h5>Upload the Icon for Crime Type</h5>
              <div class="flex xs12">
                <va-card>
                  <output>
                    <img :src="previewUrl" v-if="previewUrl" style="width:150px;height:150px;" />
                    <p v-else>No image...</p>
                  </output>
                  <input type="file" id="file" accept="image/*" v-on:change="uploadImage($event)" />
                </va-card>
              </div>
              <span style="text-align:right!important;padding-top:40px!important">
                <button class="btn btn-info" type="submit">UPDATE</button>
              </span>
            </form>
          </va-card>
        </div>
        <div class="flex md3 sm6 xs12"></div>
      </div>
    </va-card>
  </div>
</template>

<script>
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'
export default {
  components: {
    VueElementLoading,
  },
  props: ['id'],
  data () {
    return {
      previewUrl: '',
      type: '',
      visible: false,
      cname: null,
      msg: '',
      dat: [],
      data: [],
      icon: '',
    }
  },
  mounted: function () {
    this.getList()
  },
  methods: {
    upload () {
      let formData = new FormData()
      formData.append('icon', this.selectedFile)
      formData.append('id', this.id)
      this.visible = true
      axios({
        method: 'post',
        url: '/crimetype/upload/icon/' + this.id,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
          token: localStorage.getItem('token'),
        },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.visible = false

            this.$bvToast.toast(response.data.msg, {
              title: `User Type`,
              solid: true,
              variant: 'success',
            })
            this.$router.push({ name: 'crimetypes' })
          }
          if (response.data.status === false) {
            this.visible = false
            this.$bvToast.toast(response.data.msg, {
              title: `User Type`,
              solid: true,
              variant: 'danger',
            })
          }
        })

        .catch((e) => {
          console.log(e)
          this.visible = false
        })
    },
    uploadImage () {
      this.selectedFile = event.target.files[0]
      this.url = URL.createObjectURL(this.selectedFile)
      const file = event.target.files[0]
      if (file) {
        this.stat = 1
      } else {
        this.stat = 0
        return false
      }
      if (!file.type.match('image.*')) {
        // return false
        this.stat = 0
      } else {
        this.stat = 1
      }
      const reader = new FileReader()
      const that = this
      reader.onload = function (e) {
        that.previewUrl = e.target.result
      }
      reader.readAsDataURL(file)
    },
    onSubmit (evt) {
      // this.visible = true
      var data = {}
      data['cname'] = this.cname
      console.log(this.data)
      evt.preventDefault()
      axios({
        method: 'POST',
        url: '/crimetype/edit/' + this.id,
        headers: {
          token: localStorage.getItem('token'),
        },
        data: data,
      })
        .then(response => {
          this.msg = response.data.msg
          if (response.data.status === true) {
            this.$dlg.alert(
              this.msg,
              () => {
                this.$router.push({ name: 'crimetypes' })
              },
              { messageType: 'success' }
            )
          }
          if (response.data.status === true) {
            if (this.selectedFile) this.upload()
            else {
              this.$bvToast.toast(response.data.msg, {
                title: `Crime Type`,
                solid: true,
                variant: 'success',
              })
            }
            this.$router.push({ name: 'crimetypes' })
          } else {
            this.visible = false
            this.$bvToast.toast(response.data.msg, {
              title: `Crime Type`,
              solid: true,
              variant: 'danger',
            })
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    getList () {
      this.visible = true
      axios({
        method: 'GET',
        url: '/crimetype/view/' + this.id,
        headers: {
          token: localStorage.getItem('token'),
        },
        data: { id: this.id },
      })
        .then(response => {
          // console.log(response.data.data)
          if (response.data.status === true) {
            this.visible = false
            this.data = response.data.data
            this.cname = response.data.data.cname
            this.previewUrl =
              this.baseURL + response.data.data.icon
            var dt = this.data.create_date
            dt = new Date(dt)
            dt = dt.toString()
            dt = dt.slice(0, 15)
            this.data.create_date = dt
          } else {
          }
        })
        .catch(e => {
          console.log(e)
          this.visible = false
          this.errors.push(e)
          this.msg = 'failed'
        })
    },
  },
}
</script>
<style>
/* .card .content figure
{
  box-shadow: none!important;
} */
</style>
